// extracted by mini-css-extract-plugin
module.exports = {"icon":"StageCoach__icon___yQUOU","tpb":"StageCoach__tpb___3qRk-"};